/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ event: NonNullable<unknown> }} Ticketpagetitle2Inputs */

const en_ticketpagetitle2 = /** @type {(inputs: Ticketpagetitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tickets · ${i?.event}`)
};

const de_ticketpagetitle2 = /** @type {(inputs: Ticketpagetitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tickets · ${i?.event}`)
};

/**
* | output |
* | --- |
* | "Tickets · {event}" |
*
* @param {Ticketpagetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagetitle2 = /** @type {((inputs: Ticketpagetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagetitle2(inputs)
	return de_ticketpagetitle2(inputs)
});
export { ticketpagetitle2 as "ticketPageTitle" }